import { Button, DatePicker, Input, message, Table, Col, Typography, Card, Spin } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef, useState, useDeferredValue } from "react";
import { useSelector } from "react-redux";
import { serverFetch } from "../../server";
import { strDate2Server, fmtDate } from "../../extensions/utils";
import { getTableColumn, productVids, getPaymentVidName, paymentsVids } from "../../extensions/helper";
import { dictsGetPaymentVids, dictsGetUsers } from "../../extensions/dicts"
import { AddFilter, FilterItem, HoverIcon, SportTooltip } from "../../controls";
import { BtnSettingsTable, tblGetColumns } from "../../controls/table-settings.js/table-settings";
import Payment from "./payment";
import { exportExcel } from "../../extensions/export-excel";
import { ExportExcelButton, HelpButton, isMobile, PrintButton, menuSize } from "../../extensions/design";
const { Text } = Typography;

const tableName = "payments";
const reestrFilterOptions = [
  { label: "Да", value: true },
  { label: "Нет", value: false },
];

const PaymentsList = ({externalFilter = null }) => {
  const user = useSelector((s) => s.user);
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [addingFilter, setAddingFilter] = useState(true);
  const divRef = useRef(null);
  const productVidOptions = productVids;
  const [changeModalVisible, setChangeModalVisible] = useState(false);
  const [userOptions, setUserOptions] = useState([]);
  const [paymentsVid, setPaymentsVid] = useState([]);
  const [filter, setFilter] = useState({ dateBeg: dayjs(), dateEnd: dayjs()});
  const [searchText, setSearchText] = useState("");
  const deferredSearchText = useDeferredValue(searchText);
  const [tableKey, setTableKey] = useState(0);
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    setFilteredItems(applySearchFilter(deferredSearchText, items));
  }, [deferredSearchText, items]);

  const applySearchFilter = (text, sourceItems) => {
    const search = text.toLowerCase();
    if (!search) return sourceItems;
    
    const searchableFields = [
      "clientName",
      "productName",
      "userName",
      "paymentVidName",
    ];

    return sourceItems.filter(item =>
      searchableFields.some(field => {
        const val = item[field];
        return val && String(val).toLowerCase().includes(search);
      })
    );
};

  useEffect(() => {
    if (externalFilter !== null) {
      const rawFilter = { ...(externalFilter || {}) };
      setSearchText(rawFilter.searchText ?? "");
      const nextFilter = { dateBeg: filter.dateBeg, dateEnd: filter.dateEnd, ...rawFilter};
      setFilter(nextFilter);
      getData(nextFilter);
    }
  }, [externalFilter]);

  const onTableSettingsChange = () => {
    setTableKey(prev => prev + 1); // Принудительно обновляем таблицу
  }

  const onFilterChange = (changed) => {
    setFilter((prev) => ({ ...prev, ...changed }));
  };
  
  const onSearchChange = (changed) => {
    setSearchText(changed.searchText.toLowerCase());
  };

  useEffect(() => {
    dictsGetUsers(setUserOptions);
    dictsGetPaymentVids(setPaymentsVid)
  }, []);

  const handleRowClick = (record) => {
    setSelected([record.id]);
    setChangeModalVisible(true);
  };

  const addSelectedToReestr = () => {
    if (selected.length === 0) {
      message.warning("Выберите платежи");
      return;
    }
    setLoading(true);
    serverFetch("Payment/AddToReestr", { method: "POST", bodyData: { paymentIds: selected } })
      .then(data => {
        message.success(`Платежи добавлены в реестр №${data.id}`);
        setSelected([]);
        getData();
      })
      .catch(e => message.error(e.userMessage))
      .finally(() => setLoading(false));
  };

  const handleChangeModalClose = () => {
    setChangeModalVisible(false);
    setSelected([]);
    getData();
  };

  const filters = Object.entries(filter)
    .filter(([key, data]) => !["dateBeg", "dateEnd"].includes(key))
    .map(([type, data]) => ({ type, ...data }));

  const filterOptions = [
    { type: "vid", label: "Вид", inputType: "multiselect" },
    { type: "paymentVidId", label: "Вид продажи", inputType: "multiselect" },
    { type: "paymentVids", label: "Вид оплаты", inputType: "multiselect" },
    { type: "userId", label: "Пользователь", inputType: "multiselect" },
    { type: "inReestr", label: "Платеж в реестре", inputType: "select" },
  ];

  const filterLabels = {
    vid: "Вид",
    paymentVidId: "Вид продажи",
    paymentVids: "Вид оплаты",
    /* clientId: "Клиент", */
    userId: "Пользователь",
    inReestr: "Платеж в реестре",
  };
  
  const getUniqueOptions = (field) => {
    const unique = Array.from(new Set(items.map(item => item[field]).filter(Boolean)));
    return unique.map(value => ({ label: value, value }));
  };

  const filteredPaymentsVids = Array.from(
    new Map(
      paymentsVids
        .filter(({ value }) => value !== 11 && value !== 12)
        .map((item) => [item.value, item])
    ).values()
  );

  const handleAddTopFilter = (type) => {
    if (filter[type]) return;
  
    const option = filterOptions.find(opt => opt.type === type);
    const inputType = option?.inputType;
  
    let initialValue = undefined;
    let options = undefined;
  
   if (inputType === "date") {
      const now = dayjs();
      initialValue = [now.startOf("month"), now.endOf("month")];
    }
    
    if (inputType === "select" && type === "inReestr") {
      options = reestrFilterOptions;
    }

    if (inputType === "multiselect") {
    switch (type) {
      case "vid":
        options = filteredPaymentsVids;
        break;
      case "paymentVidId":
        options = productVidOptions;
        break;
      case "userId":
        options = userOptions;
        break;
      case "paymentVids":
        options = paymentsVid;
        break;
      /* case "clientId":
        options = getClientOptions();
        break; */
      default:
        options = getUniqueOptions(type);
      }
    }

    onFilterChange({ [type]: { value: initialValue, inputType, options } });
    setAddingFilter(false);
  };

  const removeTopFilter = (type) => {
    const { [type]: _, ...rest } = filter;
    setFilter(rest);
  };

  const renderFilterItem = (key, data) => (
    <FilterItem
      key={key}
      type={data.inputType}
      label={filterLabels[key] || key}
      value={data.value}
      options={data.options}
      onChange={(val) => onFilterChange({ [key]: { ...data, value: val } })}
      onRemove={() => removeTopFilter(key)}
    />
  );

  const getData = (f = filter) => {
    console.log(f)
    setLoading(true);
    setItems([]);
    setFilteredItems([]);

    const params = new URLSearchParams();

    if (f.dateBeg) params.append("BegPer", strDate2Server(f.dateBeg));
    if (f.dateEnd) params.append("EndPer", strDate2Server(f.dateEnd));

    const paramMap = {
      vid: "TransactionVids",
      paymentVidId: "ProductVids",
      clientId: "ClientIds",
      userId: "UserIds",
      paymentVids: "PaymentVids",
      inReestr: "InReestr",
    };

    Object.keys(paramMap).forEach((key) => {
      const field = f[key];
      if (!field) return;

      const val = field.value;
      if (val === undefined || val === null || val === "") return;

      const paramName = paramMap[key];
      if (Array.isArray(val)) {
        val.forEach((v) => params.append(paramName, v));
      } else {
        params.append(paramName, val);
      }
    });

    serverFetch(`Payment?${params.toString()}`)
      .then((data) => {
        setItems(data);
      })
      .catch((e) => {
        message.error(e.userMessage);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!isMobile || externalFilter === null)
      getData();
  }, [filter]);
  
  const handlePrint = () => {
    setIsPrinting(true);
    setTimeout(() => {
      window.print();
      setIsPrinting(false);
    }, 500);
  };

  const handleExportExcel = () => {
    exportExcel(items, columns, "Оплаты.xlsx");
  };

  const headerSize =  divRef.current?.querySelector('.ant-table-thead')?.offsetHeight ?? 0;
  const tableHeight = divRef.current ? (document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY) : 0;
  const tableWidth = (document.documentElement.offsetWidth - divRef.current?.getBoundingClientRect().left) ?? 0;
  const columns = [
    getTableColumn("id", "#", { type: "number", width: 50 }),
    getTableColumn("docDate", "Дата", { isFilter: true, isSorter: true, type: "date", formatFn: fmtDate, width: 85 }),
    getTableColumn("saleId", "Продажа #", { type: "number", width: 100 }),
    getTableColumn("vid", "Вид", { width: 85, render: getPaymentVidName }),
    getTableColumn("paymentVidName", "Вид оплаты", { width: 110 }),
    getTableColumn("reestrId", "Реестр #", { type: "number", width: 85 }),
    { title: "Оплата", key: "syma", dataIndex: "syma", width: 90, align: "right", render: (val, record) => (record.vid === 1 ? Number(val).toFixed(2) : ""),},
    { title: "Возврат", key: "symaRefund", dataIndex: "syma", width: 90, align: "right", render: (val, record) => (record.vid === -1 ? Number(val).toFixed(2) : ""),},
    getTableColumn("visitId", "Визит #", { type: "number", width: 85 }),
    getTableColumn("clientName", "Клиент", { isFilter: true, isSorter: true, type: "string", width: 150 }),
    getTableColumn("productName", "Основание", { type: "string", width: 150, render: (value, record) => value || record.paymentVid2Name }),
    getTableColumn("userName", "Пользователь", { type: "string", width: 150 }),
  ];


  return !isMobile ? (<div className="col-one-main">
      <div className="col-one-title" style={{padding:"0px", display:"grid"}}>
      <div className="sport-form-title" style={{display: "grid", gridTemplateColumns: "1fr 1fr", padding:"0px"}}>
        <div style={{display: "grid", gridTemplateColumns: "1fr 60px 130px 130px", alignItems: "center", marginLeft:"16px"}}>
          <Input placeholder="Введите наименование, ФИО" className="search-str" value={searchText} onChange={(e) => onSearchChange({ searchText: e.target.value })}/>
          Дата
          <DatePicker className="date-range" name="dateBeg" format="DD.MM.YYYY" allowClear={false} value={filter.dateBeg} onChange={(val) => onFilterChange({ dateBeg: val })}/>
          <DatePicker className="date-range" name="dateEnd" format="DD.MM.YYYY" allowClear={false} value={filter.dateEnd} onChange={(val) => onFilterChange({ dateEnd: val })}/>
        </div>
        <div style={{display: "flex", alignItems: "center", columnGap: "8px", justifyContent:"right", marginRight:"16px"}}>
          <Button onClick={() => getData()} style={{ width:"56px", padding:"0px"}}>
          <SportTooltip title="Обновить страницу">
            <HoverIcon src="/images/refresh.svg" hoverSrc="/images/refresh-white.svg" style={{width: 30}} alt="refresh"/>
          </SportTooltip>
          </Button>
          <Col><BtnSettingsTable name={tableName} columns={columns} onSettingsChange={onTableSettingsChange}/></Col>
          <PrintButton onClick={handlePrint} />
          <ExportExcelButton onClick={handleExportExcel} />
          {user?.isSuperadmin && <Button onClick={addSelectedToReestr} disabled={selected.length === 0}>В реестр</Button>}
          <HelpButton article="oplaty"/>
        </div>
      </div>
      </div>
        <div className="payments-list-filter-container">
          {filters.length === 0 && !addingFilter && (
            <AddFilter
              availableFilters={filterOptions}
              usedFilters={filters.map(f => f.type)}
              onAdd={handleAddTopFilter}
            />
          )}

          {filters.map((f) => renderFilterItem(f.type, f))}

          {filters.length < filterOptions.length && (
            addingFilter ? (
              <AddFilter
                availableFilters={filterOptions}
                usedFilters={filters.map(f => f.type)}
                onAdd={handleAddTopFilter}
              />
            ) : (
              filters.length !== 0 && (
                <Button
                  onClick={() => setAddingFilter(true)}
                  type="dashed"
                  className="filter-add-button"
                >
                  +
                </Button>
              )
            )
          )}
        </div>
          
      <div ref={divRef} style={{width: tableWidth}} className="col1-col">
        <div className="print-area">
          <Table key={tableKey} className="table-main" dataSource={filteredItems} loading={loading} columns={tblGetColumns(columns, tableName)} size="small" pagination={false} rowKey="id"
          scroll={isPrinting ? undefined : { y: tableHeight - 32 }} sticky={!isPrinting}
            rowSelection={{ type: user?.isSuperadmin ? 'checkbox' : 'radio', selectedRowKeys: selected, onChange: keys => setSelected(keys), renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
            onRow={(record) => ({
              onClick: () => user?.isSuperadmin ? setSelected(prev => prev.includes(record.id) ? prev.filter(id => id !== record.id) : [...prev, record.id]) : handleRowClick(record),
              onDoubleClick: () => handleRowClick(record),
            })}
            summary={(pageData) => {
              const allCols = tblGetColumns(columns, tableName);
              const flatten = (cols) => {
                const res = [];
                cols.forEach(c => {
                  if (c.children && c.children.length) res.push(...flatten(c.children));
                  else res.push(c);
                });
                return res;
              };
              const visibleCols = flatten(allCols).filter(c => c.hidden !== true);

              const totals = {
                syma: pageData.reduce((s, r) => s + (r.vid === 1 ? (Number(r.syma) || 0) : 0), 0),
                refund: pageData.reduce((s, r) => s + (r.vid === -1 ? (Number(r.syma) || 0) : 0), 0),
              };

              return (
                <Table.Summary fixed>
                  <Table.Summary.Row>
                  <Table.Summary.Cell index={0} key={0} ></Table.Summary.Cell>
                    {visibleCols.map((col, idx) => {
                      const key = col.key ?? col.dataIndex ?? String(idx);
                      const dataIndex = col.dataIndex;
                      let content = null;

                      if (idx === 0) {
                        content = <div style={{ fontSize:"12px", textWrap:"nowrap" }}><b>Итого: {pageData.length}</b></div>;
                      } else if (key === "syma") {
                        content = <div style={{ textAlign: "right", fontSize:"12px", padding:"0px" }}><b>{totals.syma.toFixed(2)}</b></div>;
                      } else if (key === "symaRefund") {
                        content = <div style={{ textAlign: "right", fontSize:"12px", padding:"0px" }}><b>{totals.refund.toFixed(2)}</b></div>;
                      }
                      const align = col.align ?? (["syma","symaRefund"].includes(dataIndex) ? "right" : "left");
                      return <Table.Summary.Cell index={idx} key={key} align={align}>{content}</Table.Summary.Cell>;
                    })}
                  </Table.Summary.Row>
                </Table.Summary>
              );
            }}
          />
        </div>
      </div>
      {changeModalVisible && <Payment onClose={handleChangeModalClose} record={items.find((s) => s.id == selected[0])}/>}
    </div>) : loading ? (
    <div className="report-loading">
      <Spin size="large" />
    </div>
    ) : (
    <div style={{paddingTop: "55px"}}>
      <div style={{display:"flex", justifyContent: "space-around", alignItems:"center"}}>
        <Text>Период с </Text>
        <DatePicker className="record-date-picker-mobile" value={filter.dateBeg} format="DD.MM.YYYY" onChange={e => onFilterChange({ dateBeg: e })} allowClear={false}/>
        <Text> по </Text>
        <DatePicker className="record-date-picker-mobile" value={filter.dateEnd} format="DD.MM.YYYY" onChange={e => onFilterChange({ dateEnd: e })} allowClear={false}/>
      </div>
      <div className="stock-scrollable-list" style={{ height: window.innerHeight - menuSize - 35, display: "flex", flexDirection: "column" }}>
      <div style={{ overflowY: "auto", flex: 1, paddingBottom: 8 }}>
        {filteredItems.map(item => {
          const isPayment = item.vid === 1;
          const sum = Number(item.syma || 0).toFixed(2);

          return (
            <Card key={item.id} className="stock-card" style={{ borderLeft: `4px solid ${selected?.includes(item.id) ? "#2f6f00" : "#d9d9d9"}`}} onClick={() => handleRowClick(item)}>
              <div className="stock-osv-item-line-triple-non-even">
                <Text strong>{fmtDate(item.docDate)}</Text>
                <Text>{getPaymentVidName(item.vid)}</Text>
                <Text strong style={{ textAlign: "right" }}> #{item.id} </Text>
              </div>

              <div className="stock-osv-item-line-double">
                <Text>Продажа #{item.saleId}</Text>
                <Text style={{textAlign: "right"}}>Вид оплаты: {item.paymentVidName}</Text>
              </div>

              <div className="stock-osv-item-line-double">
                <Text style={{ textAlign: "left", fontWeight: 600, color: isPayment ? "#3f8600" : "#cf1322" }}> Сумма: {sum} </Text>
                <Text className="sender" style={{ textAlign: "right"}}> Польз.: {item.userName}</Text>
              </div>
              <div><Text>Клиент: {item.clientName}</Text></div>
              
              <div><Text>Основание: {item.productName || item.paymentVid2Name}</Text></div>
            </Card>
          );
        })}
        {filteredItems.length === 0 && !loading && (
          <div style={{ textAlign: "center", marginTop: 20, fontSize: 14 }}> Нет данных </div>
        )}
      </div>
      <div style={{ borderTop: "1px solid #d9d9d9", padding: "8px 16px", display: "flex", justifyContent: "space-between", fontWeight: 400, fontSize: "12px"}}>
        <div>Итого: {filteredItems.length}</div>
        <div>
          Опл.: {filteredItems.reduce((s, r) => s + (r.vid === 1 ? Number(r.syma) || 0 : 0), 0).toFixed(2)}
        </div>
        <div>
          Возвр.: {filteredItems.reduce((s, r) => s + (r.vid === -1 ? Number(r.syma) || 0 : 0), 0).toFixed(2)}
        </div>
      </div>
      {changeModalVisible && <Payment onClose={handleChangeModalClose} record={items.find((s) => s.id == selected[0])}/>}
    </div>
      
    </div>  
    )
}

export default PaymentsList;